import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { getPathNameAndRestoreTransientStateProperties } from '../organisms/Sessions/Session.logic';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const ContinueSessionHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();
    const currentExerciseUrl = useAppSelector(state => state.moduleState.currentExerciseUrl);

    const onClick = () => {
        if (currentExerciseUrl === undefined) {
            return;
        }
        const pathname = getPathNameAndRestoreTransientStateProperties(currentExerciseUrl);
        navigate(pathname);
    };

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Übung fortsetzen',
        iconPath: 'icon_arrows_homescreen.svg',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={onClick}
            isHidden={false}
            disabled={!currentExerciseUrl}
        />
    );
};
export default ContinueSessionHomeScreenButton;